import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import { HeroFeature } from "components/Hero";
import { ActionBlock } from "components/Block";
import LatestArticles from "components/LatestArticles";
import LatestVideos from "components/LatestVideos";
import SubscribeForm from "components/SubscribeForm";

import Events from "./Events";
import Socials from "./Socials";
import Resources from "./Resources";

export const CommunityPageTemplate = ({ page, markdown }) => {
  return (
    <>
      <HeroFeature shade="dark" content={page.hero}>
        <SubscribeForm m="40px auto 0" maxWidth="450px" />
      </HeroFeature>
      <Events content={page.events} />
      <Socials content={page.social} />
      <Resources content={page.resources} />
      <LatestVideos
        mt="-80px"
        mb={["100px", "120px", "140px"]}
        content={page.videos}
      />
      <LatestArticles mt="-80px" content={page.blog} tag="events" />
      <ActionBlock content={page.cta} shade="light">
        <SubscribeForm m="40px auto 0" maxWidth="500px" />
      </ActionBlock>
    </>
  );
};

// CommunityPageTemplate.propTypes = {
//   title: PropTypes.string
// };

const CommunityPage = ({ data }) => {
  const { frontmatter: page } = data.markdownRemark;
  return (
    <Layout page={page} shade="dark" headerShade="image" footerShade="dark">
      <CommunityPageTemplate page={page} />
    </Layout>
  );
};

CommunityPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default CommunityPage;

export const communityPageQuery = graphql`
  query CommunityPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        page {
          title
        }
        hero {
          heading
          subheading
          background {
            childImageSharp {
              fluid(maxWidth: 1600, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
        events {
          heading
          subheading
          sections {
            title
            events {
              title
              description
              date
              location
              path
              image {
                childImageSharp {
                  fluid(maxWidth: 500, quality: 100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
          }
        }
        social {
          heading
          subheading
          items {
            icon
            title
            text
            path
          }
        }
        resources {
          heading
          subheading
          items {
            title
            path
          }
        }
        videos {
          tagline
          buttonText
          buttonPath
        }
        blog {
          heading
        }
        cta {
          heading
          subheading
          buttonText
          buttonPath
        }
      }
    }
  }
`;
